import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import ContactCTA from '../components/ContactCTA';
import '../styles/CandidateFAQs.css';

const candidateFAQs = [
  {
    question: 'What types of roles does JOY WORLDWIDE CONSULTANCY SERVICES (JWCS) place?',
    answer: 'We handle a wide spectrum of opportunities globally. Our placements include both Professional & Corporate Placements (white-collar, executive, strategic, and management roles) and Technical & Skilled Trades Placements (blue-collar, specialized, and certified technical roles).'
  },
  {
    question: 'I don\'t see a perfect role for me. Should I still submit my CV?',
    answer: 'Yes, absolutely. We maintain a robust global talent pool. Submitting your CV allows us to match your profile to new confidential opportunities that arise daily, often before they are publicly posted.'
  },
  {
    question: 'Do you help with visas, work permits, and relocation logistics?',
    answer: 'Yes. Our dedicated Immigration Services team provides comprehensive assistance with all necessary documentation, visa applications, and work permits for successful Global Placements. We are experts at managing cross-border mobility.'
  },
  {
    question: 'I am only interested in local (non-international) opportunities. Can JWCS still assist me?',
    answer: 'Definitely. While we specialize in worldwide staffing, we maintain strong partnerships for Local & Regional Job Listings in the markets we serve. Please specify your geographical preference during your application.'
  },
  {
    question: 'How do you ensure the safety and reliability of international employers?',
    answer: 'We thoroughly vet every client partner to ensure they meet high standards for safety, compliance, compensation, and work environment. We prioritize placing talent with reputable organizations committed to fair labor practices worldwide.'
  },
  {
    question: 'What sets JOY WORLDWIDE CONSULTANCY SERVICES apart from other recruiters?',
    answer: 'Our commitment to Bridging Excellence. We offer end-to-end support that combines expert talent acquisition with dedicated Immigration Services and strategic consulting. Our approach is designed to be supportive, professional, and positive, reflecting the Joy in our name.'
  },
  {
    question: 'Where can I get more information on specific roles, like compensation and benefits?',
    answer: 'Compensation, benefits, and contract details are role-specific and will be discussed confidentially with you by your dedicated JWCS consultant after your profile has been qualified and matched to an opportunity.'
  }
];

const FAQItem = ({ faq, index, isOpen, onToggle }) => {
  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <button className="faq-question" onClick={onToggle}>
        <span className="faq-number">Q{index + 1}</span>
        <span className="faq-text">{faq.question}</span>
        {isOpen ? <FaChevronUp className="faq-icon" /> : <FaChevronDown className="faq-icon" />}
      </button>
      <div className="faq-answer">
        <p>{faq.answer}</p>
      </div>
    </div>
  );
};

const CandidateFAQs = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (section, index) => {
    const key = `${section}-${index}`;
    setOpenItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const isOpen = (section, index) => {
    return openItems[`${section}-${index}`] || false;
  };

  return (
    <div className="faqs-page">
      <section className="page-hero" style={{backgroundImage: 'url(/images/FAQ-background.jpg)'}}>
        <div className="container">
          <h1>Candidate FAQs</h1>
          <p>Your Guide to Partnering with JOY WORLDWIDE CONSULTANCY SERVICES</p>
        </div>
      </section>

      <section className="faqs-intro">
        <div className="container">
          <div className="faqs-intro-grid">
            <div className="faqs-intro-content">
              <p className="intro-text">
                Find answers to commonly asked questions about our placement process, global opportunities,
                and what sets JWCS apart as your career partner.
              </p>
            </div>
            {/* <div className="faqs-intro-image">
              <img
                src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
                alt="Friendly consultant ready to help"
                className="faqs-help-img"
              />
            </div> */}
          </div>
        </div>
      </section>

      <section className="faqs-section">
        <div className="container">
          <div className="faq-category">
            <div className="faq-list">
              {candidateFAQs.map((faq, index) => (
                <FAQItem
                  key={index}
                  faq={faq}
                  index={index}
                  isOpen={isOpen('candidate', index)}
                  onToggle={() => toggleItem('candidate', index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <ContactCTA />
    </div>
  );
};

export default CandidateFAQs;
